import { render, staticRenderFns } from "./supPreviewNotice.vue?vue&type=template&id=d44d61d2&"
import script from "./supPreviewNotice.vue?vue&type=script&lang=js&"
export * from "./supPreviewNotice.vue?vue&type=script&lang=js&"
import style0 from "./supPreviewNotice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports